'use es6';

import { Record } from 'immutable';
export default Record({
  id: null,
  name: null
});